import { AirportCodes } from '../../../../types/airports';
import { UrlMapping } from '../../../../types/urlMapping';

export type AirportCodesWithMap = AirportCodes.IAH | AirportCodes.HOU;

export const airportInteractiveMapUrl: UrlMapping<AirportCodesWithMap> = {
	[AirportCodes.IAH]: {
		url: 'https://iahmaps.fly2houston.com/',
	},
	[AirportCodes.HOU]: {
		url: 'https://houmaps.fly2houston.com',
	},
};
